import { Formik, FormikHelpers } from 'formik';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { emptyLeadNote } from '../../../../store/initial';
import { LeadNote } from '../../../../types/LeadNote';
import LeadNoteForm, { LeadNoteFields } from './LeadNoteForm';

interface LeadNoteNewProps {
    closeForm: () => void;
    createHandler: (values: LeadNoteFields, actions: FormikHelpers<LeadNote>) => Promise<void>;
}

@inject('store')
@observer
class LeadNoteNew extends React.Component<LeadNoteNewProps> {
    public initialValues = () => {
        return {
            ...emptyLeadNote
        };
    };

    public render() {
        const colProps = {
            xs: 12
        };
        return (
            <Row className="block-indent__padding">
                <Col {...colProps}>
                    <Formik
                        enableReinitialize
                        initialValues={this.initialValues()}
                        onSubmit={this.handleSubmit}
                    >{LeadNoteForm({
                        controls: this.controls()
                    })}</Formik>
                </Col>
            </Row>
        );
    }

    public controls = () => {
        return (
            <>
                <Button className="right-indent" bsStyle="primary" type="submit">
                    Save
                </Button>
                <Button bsStyle="default" type="reset" onClick={this.props.closeForm}>
                    Cancel
                </Button>
            </>
        );
    };

    public handleSubmit = (values: LeadNoteFields, actions: FormikHelpers<LeadNote>) => {
        return this.props.createHandler(values, actions);
    };
}

export default LeadNoteNew;
